(function ($) {
    'use strict';

    let $container;

    // on ready
    $(() => {
        $container = $('.filter');

        onTabShown();
    });

    /**
     * Обработчик события: срабатывает при открытии вкладки (когда она уже показалась)
     *
     */
    function onTabShown() {
        $container.off('shown.bs.tab', '.filter__tab-link[data-toggle="tab"]');
        $container.on('shown.bs.tab', '.filter__tab-link[data-toggle="tab"]', (e) => tabSelected(e.target.dataset.searchedData));
    }

    /**
     * Выполняется после выбора вкладки
     *
     */
    function tabSelected(tabName) {
        tabContentShow(tabName);

        $.publish('tab-is-selected', [tabName]);
        pubEvent('tab-is-selected', {tabName: tabName});
    }

    /**
     * Отображает вкладку
     *
     */
    function tabContentShow(tabName) {
        $container.find('input[name="searched_data"]').val(tabName);

        $container.find('.filter__tab-content').removeClass('show');
        $container.find(`.filter__tab-content[data-searched-data="${tabName}"]`).addClass('show');

        let $materialsUnavailable = $('.materials-unavailable');
        if (tabName === 'materials') {
            $materialsUnavailable.show();
        } else {
            $materialsUnavailable.hide();
        }
    }

    function pubEvent(eventName, data) {
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(eventName, true, true, data);
        document.dispatchEvent(evt);
    }

})(window.jQuery);